module.exports = __webpack_public_path__ + "img/pantalla-2-sliders.14c76f08.png";